'use strict';

const global = require('./globalthis');

module.exports = global.TextDecoder;